import { render, staticRenderFns } from "./DashboardOP.vue?vue&type=template&id=078c530e"
import script from "./DashboardOP.vue?vue&type=script&lang=js"
export * from "./DashboardOP.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports